module.exports = __webpack_public_path__ + "static/media/ImgKOR.5ea26976.svg";